import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcTable from '@/components/Table.vue';
import { Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcMask from '@/components/Mask.vue';
let DeviceLicense = class DeviceLicense extends Vue {
    constructor() {
        super();
        this.headers = [];
        this.desserts = [];
        this.snackbar = new CBcSnackbar();
        this.pagination = {};
        this.maskValue = {};
        this.searchOptions = {
            deviceId: null,
            deviceNo: null,
            deviceType: null
        };
        const that = this;
        that.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        that.maskValue = {
            isShow: false
        };
        that.headers = [
            {
                text: '设备ID',
                align: 'start',
                sortable: false,
                value: 'deviceId',
            },
            { text: '设备编号', align: 'start', sortable: false, value: 'deviceNo' },
            { text: '设备类型', align: 'start', sortable: false, value: 'deviceType' },
            { text: '注册时间', align: 'start', sortable: false, value: 'registerDate' },
            { text: '到期时间', align: 'start', sortable: false, value: 'expDate' },
            { text: '天数', align: 'start', sortable: false, value: 'days' },
            { text: '创建人', align: 'start', sortable: false, value: 'creator' }
        ];
    }
    mounted() {
        const that = this;
        that.getLicense();
    }
    async getLicense() {
        const that = this;
        try {
            const emptyReg = new RegExp(/undefined|null|^\s?$/);
            const filteredSearch = Object.entries(this.searchOptions).reduce((acc, [key, value]) => {
                if (typeof value === 'string' && !emptyReg.test(value)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            const params = Object.assign({
                page: that.pagination.pageNow,
                limit: that.pagination.everyPageCount,
            }, filteredSearch);
            that.maskValue.isShow = !that.maskValue.isShow;
            const result = await that.axios.get('/api/device/licenses', { params: params });
            if (result && result.status === 200) {
                // 处理剩余时间
                that.maskValue.isShow = !that.maskValue.isShow;
                that.desserts = result.data.result;
                that.pagination.sumDetail = result.data.sum;
                const pageCount = Math.ceil(result.data.sum / that.pagination.everyPageCount) || 1;
                that.pagination.pageCount = pageCount;
            }
        }
        catch (e) {
            console.log(e);
            that.maskValue.isShow = !that.maskValue.isShow;
            that.snackbar.error('设备公钥获取失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
    }
    async getList() {
        const that = this;
        const emptyReg = new RegExp(/undefined|null|^\s?$/);
        try {
            const filteredSearch = Object.entries(this.searchOptions).reduce((acc, [key, value]) => {
                if (typeof value === 'string' && !emptyReg.test(value)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            const params = Object.assign({
                page: 1,
                limit: that.pagination.everyPageCount,
            }, filteredSearch);
            try {
                that.maskValue.isShow = !that.maskValue.isShow;
                const result = await that.axios.get('/api/device/licenses', { params: params });
                if (result && result.status === 200) {
                    // 处理剩余时间
                    that.maskValue.isShow = !that.maskValue.isShow;
                    that.desserts = result.data.result;
                    that.pagination.sumDetail = result.data.sum;
                    const pageCount = Math.ceil(result.data.sum / that.pagination.everyPageCount) || 1;
                    that.pagination.pageCount = pageCount;
                }
            }
            catch (e) {
                console.log(e);
                that.maskValue.isShow = !that.maskValue.isShow;
                that.snackbar.error('设备公钥获取失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
            }
        }
        catch (e) {
            that.snackbar.error('获取数据失败:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
    }
};
__decorate([
    Getter
], DeviceLicense.prototype, "deviceTypeList", void 0);
DeviceLicense = __decorate([
    Component({
        name: 'License',
        components: {
            BcTable,
            BcMask,
            BcSnackbar
        }
    })
], DeviceLicense);
export default DeviceLicense;
;
